import { useEffect, useState } from "react";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";
import { api } from "@/lib/api";

const FALLBACK = [
  { symbol: "AU", name: "Gold", price: 2412.55, unit: "USD/oz", change_pct: 0.42 },
  { symbol: "CU", name: "Copper", price: 4.31, unit: "USD/lb", change_pct: 1.21 },
  { symbol: "NI", name: "Nickel", price: 8.06, unit: "USD/lb", change_pct: -0.74 },
  { symbol: "LI", name: "Lithium", price: 14250, unit: "USD/t", change_pct: 0.95 },
  { symbol: "U", name: "Uranium", price: 88.15, unit: "USD/lb", change_pct: 2.1 },
];

const formatPrice = (p) =>
  p >= 1000
    ? p.toLocaleString("en-US", { maximumFractionDigits: 0 })
    : p.toFixed(2);

const TickerItem = ({ c }) => {
  const positive = c.change_pct >= 0;
  const isLive = c.source && c.source !== "reference";
  return (
    <span
      className="inline-flex items-center gap-2 px-5 border-r border-white/10"
      data-testid={`ticker-item-${c.symbol.toLowerCase()}`}
    >
      {isLive && (
        <span className="inline-flex items-center gap-1 text-[9px] font-mono text-emerald-300 uppercase tracking-widest">
          <span className="w-1 h-1 rounded-full bg-emerald-300" />
          Live
        </span>
      )}
      <span className="font-archivo font-bold text-[11px] tracking-widest text-white/90">
        {c.symbol}
      </span>
      <span className="text-[11px] uppercase tracking-wider text-white/55">
        {c.name}
      </span>
      <span className="font-mono text-[12px] text-white">
        {formatPrice(c.price)}
      </span>
      <span className="text-[10px] font-mono text-white/45">{c.unit}</span>
      <span
        className={`inline-flex items-center gap-0.5 font-mono text-[12px] ${
          positive ? "text-emerald-300" : "text-orange-300"
        }`}
      >
        {positive ? (
          <ArrowUpRight size={12} strokeWidth={2.5} />
        ) : (
          <ArrowDownRight size={12} strokeWidth={2.5} />
        )}
        {positive ? "+" : ""}
        {c.change_pct.toFixed(2)}%
      </span>
    </span>
  );
};

export const CommodityTicker = () => {
  const [data, setData] = useState(FALLBACK);

  useEffect(() => {
    let mounted = true;
    api
      .get("/market-ticker")
      .then((res) => mounted && Array.isArray(res.data) && setData(res.data))
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  const doubled = [...data, ...data];

  return (
    <div
      className="bg-bb-navy border-y border-white/10 overflow-hidden"
      data-testid="commodity-ticker"
    >
      <div className="bb-container">
        <div className="flex items-center">
          <span className="inline-flex items-center px-3 py-2 bg-bb-copper text-white font-archivo font-bold text-[11px] tracking-widest uppercase">
            Live · Markets
          </span>
          <div className="relative flex-1 overflow-hidden py-2">
            <div className="ticker-track">
              {doubled.map((c, i) => (
                <TickerItem c={c} key={`${c.symbol}-${i}`} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommodityTicker;
